import { AppBar, Toolbar, IconButton, Typography, Box, Stack } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

export interface AppNavbarProps {
  /**
   * Callback when menu button is clicked
   * Should open the mobile drawer
   */
  onMenuClick: () => void;
}

/**
 * App Navbar Component (Mobile)
 *
 * Top navigation bar for mobile devices.
 * Contains menu button to open drawer and app branding.
 *
 * Visible only on xs-sm breakpoints (<900px).
 *
 * @example
 * ```tsx
 * <AppNavbar onMenuClick={() => setDrawerOpen(true)} />
 * ```
 */
export function AppNavbar({ onMenuClick }: AppNavbarProps) {
  return (
    <AppBar
      position="fixed"
      sx={{
        display: { xs: 'block', md: 'none' },
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <IconButton color="inherit" aria-label="Open menu" edge="start" onClick={onMenuClick}>
          <MenuIcon />
        </IconButton>
        <Stack direction="row" spacing={1} alignItems="center">
          <Box
            component="img"
            src="/assets/logo.png"
            alt="StyleConnect"
            sx={{
              width: 24,
              height: 24,
              borderRadius: 0.5,
              objectFit: 'contain',
            }}
          />
          <Typography variant="h6" component="div" sx={{ fontWeight: 700, fontSize: '1.1rem' }}>
            StyleConnect
          </Typography>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}
